import React, { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AIChat } from "@/components/AIChat";
import { Hero } from "@/components/sections/Hero";
import { Sectors } from "@/components/sections/Sectors";
import { WhyUs } from "@/components/sections/WhyUs";
import { Testimonials } from "@/components/sections/Testimonials";
import { BlogSection } from "@/components/sections/BlogSection";
import { Comparison } from "@/components/sections/Comparison";
import { Process } from "@/components/sections/Process";
import { FAQ } from "@/components/sections/FAQ";
import { QuoteForm } from "@/components/sections/QuoteForm";
import { Booking } from "@/components/sections/Booking";
import { Contact } from "@/components/sections/Contact";
import { setSEO } from "@/lib/seo";

export default function Home() {
  useEffect(() => {
    setSEO({
      title: "I-LEASE SRL — Leasing, Renting & LLD en Belgique | Voitures, Camions, Génie Civil",
      description: "I-LEASE SRL — courtier indépendant en leasing, renting et location longue durée (LLD) en Belgique depuis 2015. Financement de voitures, camions et engins de génie civil partout en Belgique. Réponse en 48h.",
      path: "/",
    });
  }, []);
  return (
    <div className="relative">
      <Navbar />
      <main>
        <Hero onOpenChat={() => document.querySelector('[data-testid="ai-chat-open"]')?.click()} />
        <Sectors />
        <WhyUs />
        <Comparison />
        <Process />
        <FAQ />
        <Testimonials />
        <BlogSection />
        <QuoteForm />
        <Booking />
        <Contact />
      </main>
      <Footer />
      <AIChat />
    </div>
  );
}
